import dayjs from 'dayjs'

export default function appDateShort (input: string, ignoreValues: string[] = []) {
  if (ignoreValues.includes(input)) return input
  const result = dayjs(input).format('MM/DD/YY')
  if (result === 'Invalid Date') {
    return ''
  }
  return result
}
